/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext } from 'react';
import '../../../styles/store-selector.scss';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { useInStoreState } from '../useInStoreState';
import { InNearbyStoreDesktop } from './InNearbyStoreDesktop';
import { InNearbyStoreMobile } from './InNearByStoreMobile';

export const InNearbyStoreContainer = () => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  const {
    isNearbyStores,
    storeSearch,
    toggleChangeStore,
    setIsNearbyStores,
    multiStoreSelection,
    onMultiStoreSelectionChange
  } = useInStoreState();

  const onNearbyStoresToggle = () => {
    setIsNearbyStores(!isNearbyStores);
  };

  return isMobile
    ? (
      <InNearbyStoreMobile
        isNearbyStores={isNearbyStores}
        onNearbyStoresToggle={onNearbyStoresToggle}
        toggleChangeStore={toggleChangeStore}
        storeSearch={storeSearch}
        multiStoreSelection={multiStoreSelection}
        onMultiStoreSelectionChange={onMultiStoreSelectionChange}
        setIsNearbyStores={setIsNearbyStores}
      />
    )
    : (
      <InNearbyStoreDesktop
        isNearbyStores={isNearbyStores}
        onNearbyStoresToggle={onNearbyStoresToggle}
        toggleChangeStore={toggleChangeStore}
        storeSearch={storeSearch}
        multiStoreSelection={multiStoreSelection}
        onMultiStoreSelectionChange={onMultiStoreSelectionChange}
        setIsNearbyStores={setIsNearbyStores}
      />
    );
};